(function ($) {
    $(() => {
        let addedFilesCounter = 0;
        $('#fileinput').fileupload({
            url: ajax.ajaxurl,
            dataType: 'json',
            autoUpload: false,
            add: function (e, data) {
                var fileSize = data.originalFiles[0]['size'];
                var fileType = data.originalFiles[0]['type'];
                $(".join-btn").prop("disabled", true);
                if (addedFilesCounter >= 1){
                    Swal.fire({
                            title: 'Csak egy fájlt tölts fel!',
                            text: '',
                            icon: 'error',
                            confirmButtonClass: 'btn btn-primary-cutted-corner btn-primary-neon m-0',
                            buttonsStyling: false
                        }
                    );
                    $(".join-btn").prop("disabled", false);
                }
                else if (fileSize > 2000000) {
                    Swal.fire({
                            title: 'Túl nagy fájl!',
                            text: '',
                            icon: 'error',
                        }
                    );
                    $(".join-btn").prop("disabled", false);
                }

                else if (fileType !== 'application/pdf' && fileType !== 'image/png' && fileType !== 'image/jpeg') {
                    Swal.fire({
                            title: 'Nem megfelelő fájlformátum! (PDF, PNG, JPEG)',
                            text: '',
                            icon: 'error',
                        }
                    );
                    $(".join-btn").prop("disabled", false);
                }

                else {
                    addedFilesCounter++;
                    data.submit();
                }
            },
            done: function (e, response) {
                $(".join-btn").prop("disabled", false);
                if(response.result.success === true && response.result.data.status == 'ok'){
                    $('.custom-file-label').removeClass('file-error');
                    var file = response.result.data.file;
                    var file_name = file.name;
                    var short_file_name = file_name;
                    if (file_name.length > 18)
                        short_file_name = file_name.substring(0,18) + '...';
                    $('#files').fadeIn().append('<h6 data-file_name="' + file.url + '">' + short_file_name + '<i class="delete-icon fa fa-trash-alt" aria-hidden="true"></i></h6>');
                }
            }
        });

        $(".join-form").on("submit", function (e) {
            e.preventDefault();
            var $this = $(this);

            var name_string = $('#name').val();
                if ( addedFilesCounter == 1) {
                    $(this).find(".join-btn").prop("disabled", true);

                    var $input_fn = $('input[name=uploaded_files_json]');
                    $input_fn.val('');

                    $("#files h6").each(function (i, element) {
                        $input_fn.val($(element).data('file_name'));
                    });

                    var formdata = $this.serializeArray();
                    $.ajax({
                        url: ajax.ajaxurl,
                        type: 'POST',
                        data: {
                            action: "join_form",
                            datas: formdata
                        },
                        success: function (data) {
                            var result = JSON.parse(data);

                            Swal.fire({
                                // title: result["title"],
                                text: result["title"],
                                imageUrl: '/wp-content/themes/wp-dmlab/assets/img/eredmeny.svg',
                                imageHeight: 100,
                                imageAlt: 'Pipa',
                                button: 'ok'
                            });

                            if (result['status'] == 'success') {
                                resetJoinForm();
                            }

                        }
                    }).done(function (response) {
                        $this.find(".join-btn").prop("disabled", false);
                    });
                } else {
                    if (addedFilesCounter == 0) {
                        $('.custom-file-label').addClass('file-error');
                        $('.file_error_text').addClass('show');

                        Swal.fire({
                            title: 'Fájl feltöltése kötelező',
                            text: '',
                            icon: 'error',
                            button: 'ok'
                        });
                    }
                }
        });

        function resetJoinForm() {
            $(".join-form").trigger("reset");
            $("input[name='uploaded_files_json']").val('');
            addedFilesCounter = 0;
            $('#files h6').each(function () {
                $(this).remove();
            })
        }
    });
})(jQuery);